import './App.css';
import Experience from "./Components/Experience/Experience";
import Education from "./Components/Education/Education";
import Contact from "./Components/Contact/contact";
import Skills from "./Components/Skills/skills";
import Intro from "./Components/Intro/Intro";
import AboutMe from "./Components/AboutMe/aboutMe";
import Projects from "./Components/Projects/Projects";

function App() {
    return (
        <div className="App">
            <Intro/>
            <AboutMe/>
            <Skills/>
            <h1 className={"experience-heading"}>Experience</h1>
            <Experience/>
            <Projects/>
            {/*<h1 className={"experience-heading"}>Education</h1>*/}
            {/*<Education/>*/}
            <div style={{backgroundColor: "rgba(30, 30, 29, 255)"}}>
                <Contact/>
                <hr className="solid"/>
                <div className={"copyRight"}>
                    <h1>Copyright © 2021 Mrigank Anand. All rights reserved</h1>
                </div>

            </div>
        </div>
    );
}

export default App;
